import actionTypes from '../actions/reduxActions/actionTypes';

/**
 * The authentication token contains the following claims:
 * {
 *      sub: string,
 *      given_name: string,
 *      family_name: string,
 *      email: string,
 * }
 *
 * @type {{
 *   authenticationToken: string
 *   tenantId: string,
 *   tenantName: string,
 *   username: string,
 *   orgId: string,
 *   orgName: string,
 *   roleName: string,
 *   createdAt: string,
 *   email: string,
 *   firstName: string,
 *   id: string,
 *   lastName: string,
 *   organizations: [
 *       {
 *           id: string,
 *           name: string
 *       }
 *   ],
 *   password: null,
 *   tenants: [],
 *   verified: bool
 *  }}
 */
const defaultState = {
    authenticationToken: null,
    tenantId: null,
    tenantName: null,
    username: null,
    orgId: null,
    orgName: null,
    roleName: null,
    createdAt: null,
    email: null,
    firstName: null,
    id: null,
    lastName: null,
    organizations: [],
    password: null,
    tenants: [],
    verified: false,
};

const currentUser = (user = defaultState, { type, payload, error, meta }) => {
    switch (type) {
        case actionTypes.CURRENT_USER_SET: {
            return payload;
        }

        case actionTypes.CURRENT_USER_REMOVE:
            return defaultState;

        default:
            return user;
    }
};

export default currentUser;
